module.exports = __webpack_public_path__ + "static/media/susan1.6b5c82fb.mp3";